import * as core from '../../../../../../../core'

import { query } from './sponsors-table.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.sponsors-table',
    description: 'Displays a list of sponsors in a table widget',
    name: 'RP Explore - Sponsors Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
